import React from 'react';
import { AvailabilityPageSkeleton } from '@jira/servicedesk__availability/src/AvailabilityPageSkeleton.tsx';
import { token } from '@atlaskit/tokens';
import Skeleton from '@atlaskit/skeleton';
import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Box } from '@atlaskit/primitives/compiled/box';

const styles = cssMap({
	container: {
		paddingTop: token('space.300'),
		paddingRight: token('space.300'),
		paddingBottom: token('space.300'),
		paddingLeft: token('space.300'),
	},
	contentContainer: {
		marginTop: token('space.600'),
	},
});

export const PageSkeleton = (): React.JSX.Element => (
	<Box xcss={styles.container}>
		<Flex direction="row" justifyContent="space-between" alignItems="center">
			<Skeleton height="29px" width="200px" />
		</Flex>
		<Box xcss={styles.contentContainer}>
			<AvailabilityPageSkeleton />
		</Box>
	</Box>
);
